/**
 * HospitalScreen - Hospital selection screen for mobile emulator
 */
import React from 'react';
import { Building2, ChevronRight, RefreshCw } from 'lucide-react';
import type { Hospital } from '../../services/hospitalService';

interface HospitalScreenProps {
  hospitais: Hospital[];
  loadingHospitais: boolean;
  loadingLocais: boolean;
  error: string;
  onSelectHospital: (hospital: Hospital) => void;
}

export const HospitalScreen: React.FC<HospitalScreenProps> = ({
  hospitais,
  loadingHospitais,
  loadingLocais,
  error,
  onSelectHospital,
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">Selecione o Hospital</h2>
        <p className="text-sm text-gray-600">{hospitais.length} hospitais disponíveis</p>
      </div>

      {error && (
        <div className="bg-red-100 border-2 border-red-200 rounded-lg p-3 mb-4">
          <p className="text-red-800 text-sm font-medium">⚠️ {error}</p>
        </div>
      )}

      {loadingHospitais ? (
        <div className="flex justify-center py-12">
          <RefreshCw className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : (
        <div className="space-y-3">
          {hospitais.map((hospital) => (
            <button
              key={hospital.id}
              onClick={() => onSelectHospital(hospital)}
              disabled={loadingLocais}
              className="w-full bg-white border-2 border-gray-200 hover:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg p-4 transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-bold text-gray-900 text-lg">{hospital.nome_fantasia}</p>
                  <p className="text-sm text-gray-600">Código: {hospital.codigo}</p>
                  {hospital.contato && (
                    <p className="text-xs text-gray-500 mt-1">{hospital.contato}</p>
                  )}
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
